// src/components/CompaniesSection.jsx
import Image from "next/image";

const logoData = [
  { name: "Google", url: "https://d3kl8zsmmx4oop.cloudfront.net/Google_c2d8e527c7.svg", className: "w-32" },
  { name: "Swiggy", url: "https://d3kl8zsmmx4oop.cloudfront.net/layer1_001742dcec.svg", className: "w-28" },
  { name: "Zoho", url: "https://d3kl8zsmmx4oop.cloudfront.net/Vector_8abe02abf9.svg", className: "w-28" },
  { name: "Philips", url: "https://d3kl8zsmmx4oop.cloudfront.net/Philips_8bcd20d6c4.svg", className: "w-32" },
  { name: "Microsoft", url: "https://d3kl8zsmmx4oop.cloudfront.net/Google_1_eb75fe0681.svg", className: "w-32" },
  { name: "Zomato", url: "https://d3kl8zsmmx4oop.cloudfront.net/Mask_group_3_da9617f594.png", className: "w-32" },
  { name: "Paytm", url: "https://d3kl8zsmmx4oop.cloudfront.net/Mask_group_4_f997505a34.png", className: "w-28" },
  { name: "Snapdeal", url: "https://d3kl8zsmmx4oop.cloudfront.net/g3483_ecdb0a4173.svg", className: "w-32" },
  { name: "Apna", url: "https://d3kl8zsmmx4oop.cloudfront.net/Mask_group_6_307be2c613.png", className: "w-28" },
  { name: "Walmart", url: "https://d3kl8zsmmx4oop.cloudfront.net/Path_6_36897189a6.svg", className: "w-32" },
  { name: "Disney+ Hotstar", url: "https://d3kl8zsmmx4oop.cloudfront.net/Group_77e1b17517.svg", className: "w-40" },
  { name: "Uber", url: "https://d3kl8zsmmx4oop.cloudfront.net/Vector_1_3f59974b49.svg", className: "w-28" },
  { name: "Philips", url: "https://d3kl8zsmmx4oop.cloudfront.net/Philips_1_c50dd5b8cb.svg", className: "w-32" },
  { name: "Adobe", url: "https://d3kl8zsmmx4oop.cloudfront.net/LOGO_07fbe3c627.svg", className: "w-28" },
];

export default function CompaniesSection() {
  return (
    <section className="py-6 w-[90%] md:w-[80%] mx-auto">
      <h2 className="text-[#002726] text-xl font-medium mb-12">
        Our alumni work at top brands like
      </h2>
      
      <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-x-6 gap-y-12">
        {logoData.map((logo, index) => (
          <div key={index} className="flex items-center justify-center">
            <div className={`relative ${logo.className} h-12 flex items-center w-[85px] h-auto]`}>
              <Image
                src={logo.url}
                alt={logo.name}
                fill
                className="object-contain"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}